const BasicInfoCardQuickActionsStyles = {
  BasicInfoQuickActionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "20px",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.09) inset",
    background: "#FCFEFF",
    color: "#1D252B",
    borderRadius: "9px",
    "@media (max-width: 1200px)": {
      flexDirection: "row",
      alignItems: "center",
    },
    "@media (max-width: 900px)": {
      justifyContent: "space-between",
    },
  },
  quickStyle: {
    color: "#1D252B",
    fontFamily: "Noto Sans",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 300,
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  contactPop: {
    marginTop: "10px",
    marginLeft: "-40px",
    "@media(max-width: 780px)": {
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  taskContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    marginTop: "20px",
  },
  openTasksLink: {
    fontWeight: 500,
    fontSize: "1.3rem",
    textAlign: "center",
    marginBottom: 1,
    opacity: 1,
    cursor: "pointer",
    "&.Mui-disabled": {
      color: "text.disabled",
      opacity: 0.5,
      cursor: "default",
    },
  },
  taskCountText: {
    fontWeight: "bold",
    textAlign: "center",
    color: "text.primary",
  },
  drawerContainer: {
    width: 350,
    padding: 2,
  },
  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
  },
  titleText: {
    fontWeight: "bold",
  },
  taskList: {
    width: "100%",
  },
  taskItem: {
    marginBottom: 2,
    padding: 2,
    borderRadius: 2,
    border: "1px solid #e0e0e0",
    display: "block",
  },
  taskHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 1,
  },
  taskLink: {
    fontWeight: "bold",
    textAlign: "left",
    color: "primary.main",
    cursor: "pointer",
  },
  overdueText: {
    color: "#d32f2f",
    fontWeight: "medium",
  },
  normalText: {
    color: "text.secondary",
    fontWeight: "normal",
  },
};

export default BasicInfoCardQuickActionsStyles;
